<template>
  <div class="whole-div-PCQ">

    <!--      第二行-->
    <div class="div2-PCQ">
      <div class="div2-div1-PCQ">
        <div class="div2-div1-div1-PCQ" @click="clickQuestion(item)" v-for="(item,index) in commonQuestionsList" :key="index">
          <!--          标题+时间-->
          <div class="div2-div1-div1-div1-PCQ">
            <a class="div2-a1-PCQ">{{item.title}}</a>
            <a class="div2-a2-PCQ">{{item.dateTime}}</a>
          </div>
          <!--          内容-->
          <div class="div2-div1-div1-div2-PCQ">
            <a class="div2-a3-PCQ">{{item.details}}</a>
          </div>
          <!--          按钮：了解详情-->
          <div class="div2-div1-div1-div3-PCQ">
            <div class="div2-div1-div1-div3-div-PCQ">
              了解详情
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    第3行-->
    <div class="div3-PCQ">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalPages">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import '../../css/pc/PCQ_PcCommonQuestions.css'

  export default {
    name: "PcCommonQuestions",
    data() {
      return {
        //分页记录
        currentPage: 1,
        pageSize: 4,
        totalPages: 9,
        //常见问题列表
        commonQuestionsList: [
        ],
        //常见问题总列表
        commonQuestionsLists: [{
          title: '畜禽无害化的正确处理步骤',
          dateTime: '2024-05-17',
          details: '我们大家都知道，一些动物死了之后就会留下很多病菌，如果不及时处理或者正确处理的话会导致病菌的扩散，危害人们身体的健康，那么我们如何对它们进行无害化处理呢？就让专业的无害化处理设备的厂家给大家介绍下，希望分享的内容对大家有帮助。\n' +
            '　　一点，如果是养殖户发现自己的畜禽大量死亡，那么就需要立即上报，让有关部门进行勘察，并收集死亡的畜禽，统一来进行无害化处理，后期就会有相应的设备进行处理。第二点，另外要对死亡的畜禽先进行消毒处理，以防扩散病菌，也可以进行深度填埋，深埋不能少于1米或者更深，并且在深埋后在周边也要再次进行消毒处理。第三点，咱们大家深埋要注意的是，一定要远离居民区，并且要远离水源，深埋地点要在下风向，这样是为了防止遭到污染。第四点，对于相对大型的养殖户而言，如果是属于正常死亡的畜禽，那么可以自行购买无害化处理的设备，并按照相关规定进行无害化焚烧处理。',
        }, {
          title: '无害化处理设备相比较传统处理方法的优势',
          dateTime: '2024-05-17',
          details: '相较于焚烧处理法的优势：\n' +
            '（一）环保：焚烧产生的烟气污染环境。而养猪场无害化处理设备采用高温化制的方法将死猪进行灭菌熔炼处理，产生的气味由脱臭罐或废气设备处理，具有环保的优势。\n' +
            '\n相较于深埋处理法的优势：\n' +
            '（一）省时：选择深埋的方式处理死猪，需要花费精力选址，掩埋地远离居民区、学校、水源，并且需要挖出深度为2m-7m的深坑，且高于地下水位1m，而且需要对坑底做生石灰处理，非常耗费时间。而养猪场无害化处理设备只需将生猪推入设备内，开动机器，在2-4小时内即可解决，非常省时。\n' +
            '（二）循环利用：养猪场无害化处理设备具有可循环利用的优势，深埋处理法需占用土地资源，对于大规模养殖场不是长久之计。\n' +
            '\n相较于发酵处理法的优势：\n' +
            '(一)周期短：发酵处理是通过堆肥，依靠微生物将动物尸体进行降解，虽然可杀死病原微生物，但是处理周期过长，遇上大规模病害情况无法解决。而无害化处理设备批次处理量可达30吨以上，处理时间仅3-4小时，处理时间短，可解决动物突发性大规模死亡事件。',
        }, {
          title: '无害化智能处理设备的特点',
          dateTime: '2024-05-17',
          details: '（一）此设备采用高温高压处理，能更彻底的杀死杀灭病菌。\n' +
            '（二）使用畜禽无害化智能处理设备的重点不仅仅在于杀灭畜禽中含有的有害病菌，还可将剩下的物料制成饲料废物编程珍宝，并提高经济效益。\n' +
            '（三）畜禽无害化智能处理设备更加的智能化，减少了人工操作，降低了使用难度，更加具有经济效益。\n' +
            '（四）畜禽无害化智能处理设备处理的过程可达到无二次污染，对环境有着很好的保护作用。\n' +
            '（五）畜禽无害化处理的应用加上政府的管辖与补助也从根本上解决了病死畜禽流入市场的问题。',
        }, {
          title: '动物无害化处理设备的原理',
          dateTime: '2024-05-17',
          details: '在处理动物尸体方面已有多年历史，但由于种种原因，仍有不少病死的畜禽经过不良商贩处理后流入市场，严重影响人们的健康。为了对病死畜禽进行彻底的无害化处理，现在使用化制的技术来进行处理，这样的设备我们叫做动物无害化处理设备，它的工艺原理是将病禽高温高压杀菌熟练后的脂肪和水去除，在高温的同时进行了杀菌的工作，杀菌后就已经变成了无害物料，后续可以使用多种的处理方式，比如说可以通过干燥粉碎成有机肥。这一过程可以从根本上解决病畜的无害化治疗问题。',
        }, {
          title: '病死畜禽无害化处理的办法',
          dateTime: '2024-05-17',
          details: '（一）高温消毒：使用高温方法，如焚烧或高温蒸汽处理，可以有效地杀灭病原体和病菌，防治疾病的传播。这是一种彻底的处理方式，但需要专业的设备和操作。\n' +
            '（二）填埋：将病死畜禽尸体安全地埋在合适的地点。这需要遵循环境法规，避免地下水受到污染。填埋需要在专门的填埋场进行，确保尸体完全埋入土壤下。\n' +
            '（三）化制肥料：一些地方可以将病死畜禽尸体进行化制，制成肥料。这需要专业设备和控制，以确保肥料中的病原体得到有效的处理，以及不会对环境造成污染。\n' +
            '（四）发酵堆肥：将病死畜禽尸体与有机物一起放置在适当的堆肥堆中进行发酵，通过微生物的活动分解尸体。这需要控制好发酵的条件，确保病原体被有效消除。\n' +
            '（五）气化处理： 利用气化设备将病死畜禽尸体转化为气体，残渣可以进一步处理为肥料。这种方法需要专业技术和设备。\n' +
            '微生物降解： 利用特定的微生物来降解病死畜禽尸体，将其分解为较小的分子。这需要科学家和专家来控制微生物的活动。',
        }, ]
      }
    },
    mounted() {
      this.computedTotalPages();
      this.paginating(1);
    },
    methods: {
      //问题点击
      clickQuestion(item){
        //赋值
        this.$store.state.questionIntroduce=item;
        this.$router.push({path:'/PcQuestionIntroduce'})
      },
      //分页
      paginating(id) {
        let that = this;
        let leftPage = (id - 1) * that.pageSize;
        let rightPage = id * that.pageSize;
        that.commonQuestionsList=[];
        for (let i = leftPage; i < rightPage; i++) {
          if (i < that.commonQuestionsLists.length) {
            that.commonQuestionsList.push(that.commonQuestionsLists[i]);
          }
        }
      },
      //判断页面总数
      computedTotalPages(){
        let that=this;
        that.totalPages=that.commonQuestionsLists.length;
      },
      //点击分页按钮
      handleCurrentChange(val) {
        this.paginating(val);
        console.log(`当前页: ${val}`);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/computer/second/PcCommonQuestions.vue